var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('img',{staticClass:"lcp-logo",attrs:{"width":"225","height":"40","src":require("@/assets/monitorLogoXS.png"),"alt":"LCP Monitor Pending"}})
}
var staticRenderFns = []

export { render, staticRenderFns }